import InfiniteScroll from "react-infinite-scroll-component";
import { ICollection } from "services/types";
import { CollectionTile } from "./CollectionTile";
import { RawCollectionTile } from "./RawCollectionTile";
import { GifBlockPlaceholder } from "components/UI/Skeleton";
import { routes } from "routes";
import { ReactComponent as LikedIcon } from "components/icons/LikedIcon.svg";
import { useUserCollectionsData } from "hooks/useUserCollectionsData";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TABLET_WIDTH } from "hooks/useDeviceType";
import "./CollectionsList.scss";

interface ICollectionsListProps {
  userName: string;
  showSaved: boolean;
}

export const CollectionsList = (props: ICollectionsListProps): JSX.Element => {
  const { userName, showSaved } = props;
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);
  const {
    items,
    isError,
    isLoading,
    hasNextPage,
    fetchNextPage
  } = useUserCollectionsData({ userName });

  const renderCollectionItems = () => {
    if (!items.length && isLoading) {
      // eslint-disable-next-line no-magic-numbers
      return new Array(12).fill("").map((___, index) => (
        <div className="collectionPlaceholder" key={index}>
          <GifBlockPlaceholder/>
          <div className="title"></div>
        </div>
      ));
    }

    return (
      <>
        {showSaved && (
          <RawCollectionTile
            link={routes.favourites()}
            thumbnail={<LikedIcon />}
            published={false}
            label="Likes"
          />
        )}
        {items.map((item: ICollection) => (
          <CollectionTile
            key={item.folderId}
            userName={props.userName}
            collection={item}
          />
        ))}
      </>
    );
  };

  if (isError) {
    return <p>Error reading collections.</p>;
  }

  return (
    <div className="collections">
      <InfiniteScroll
        dataLength={items.length}
        hasMore={!!hasNextPage}
        next={fetchNextPage}
        loader={<></>}
        scrollableTarget={!isDesktop ? "scrollableDiv" : undefined}
      >
        <div className="tiles">
          {renderCollectionItems()}
        </div>
      </InfiniteScroll>
    </div>
  );
};
